<mat-card *ngIf="!isLoading && isOpenContent1" class="reports-container">
    <ng-container *ngIf="!isLoading">
        <ng-container *ngIf="!patient">
            <p><strong>Patient is not registered yet.User needs to register a Patient!</strong></p>
        </ng-container>
        <ng-container *ngIf="patient">
            <mat-card-header class="nopadding">
                <span class="card-header-value">MY REPORTS</span>
            </mat-card-header>
            <ng-container *ngIf="!isAnalysisRequestedStatus">
                <p class="no-reports"><strong>No reports available yet</strong></p>
                <p class="info-text">
                    You don’t have any reports to view at the moment.
                </p>

                <button mat-flat-button color="primary" class="request-btn" (click)="addAnalysisRequest()">
                    Request Analysis
                </button>

                <p class="description">
                    Once we’ve completed your analysis and you’ve had your consultation with a clinical
                    specialist, your reports will appear here. You’ll be notified as soon as they’re ready
                    to view or download.
                </p>
            </ng-container>
            <ng-container *ngIf="isAnalysisRequestedStatus">
                <mat-card-content class="no-report">
                    <div class="template-container">
                        <div>
                            <ul class="adjustspace">
                                <li *ngFor="let obj of patientReport?.content">
                                    <button
                                        (click)="viewReport(obj?.patientId,obj?.templateId, obj?.snpPickerOutputPath, obj?.reportPdfPath, obj?.templateName)"
                                        [disabled]="!isReportEnabled(obj) || !obj.isReleased"
                                        class="template-details"
                                        target="_blank">
                                        <div class="template-body">
                                            <span class="requested-template" *ngIf="!isReportReleased(obj)"><strong>Requested</strong></span>
                                            <div class="inner-body">
                                                <label>{{obj?.templateName}}</label>
                                                <span class="templateType">{{obj.refTemplateType}}</span>
                                            </div>
                                        </div>
                                        <div class="template-footer" (click)="$event.stopPropagation()">
                                            <span class="float-left">
                                                {{ obj.modifiedDate | date:'MMM yyyy' }}
                                            </span>
                                            <span class="float-right">
                                                <mat-icon class="download-icon" mat-icon-button
                                                    [matMenuTriggerFor]="menu"
                                                    [matMenuTriggerDisabled]="!isReportEnabled(obj) || !obj.isReleased"
                                                    [ngClass]="{ 'disabled-icon': !isReportEnabled(obj) || !obj.isReleased }">more_vert</mat-icon>
                                                <mat-menu class="download-icon" #menu="matMenu" yPosition="above"
                                                    xPosition="before" autoFocus="false">
                                                    <button mat-menu-item
                                                        (click)="viewReport(obj?.patientId,obj?.templateId, obj?.snpPickerOutputPath, obj?.reportPdfPath, obj?.templateName)">
                                                        <mat-icon class="white-icon"
                                                            matTooltip="View report">visibility</mat-icon>
                                                        <span>View</span>
                                                    </button>
                                                    <button mat-menu-item
                                                        (click)="downloadTemplateReport(obj?.reportPdfPath, obj?.templateName)">
                                                        <mat-icon class="white-icon"
                                                            matTooltip="Download report">file_download</mat-icon>
                                                        <span>Download</span>
                                                    </button>
                                                </mat-menu>
                                            </span>
                                        </div>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <mat-paginator *ngIf="isContentAvailable" id="organisation_pagination" [pageSize]="pageSize"
                        [showFirstLastButtons]='true' [hidePageSize]="true" (page)="pageChange($event)"
                        [ngClass]="{ 'display-none': this.paginator?.length < pageSize }"></mat-paginator>
                </mat-card-content>
            </ng-container>
        </ng-container>
    </ng-container>
</mat-card>
<mat-card *ngIf="isOpenContent">
    <mat-card-header>
        <span class="spacer">
        </span>
        <span class="close-alignment">
            <a id="close_button" (click)="closeContent()">
                <mat-icon class="mat-tertiary">close</mat-icon>
            </a>
        </span>
    </mat-card-header>
    <mat-card-content>
        <div class="width-100">
            <doc-viewer [module]="module" [height]="'80vh'" [config]="config"></doc-viewer>
        </div>
    </mat-card-content>
</mat-card>
